<script>
/**
1) attrs / props / style: 会直接传给对应组件的内部
2) 重置时，会用 params 的初始值重置
3) 可以用 slot 来展示特殊的表单组件
4) 使用示例：
items = [
  {
    label: "输入框",
    type: "input",
    key: "xxx",
    placeholder: "xxx", // 选填，默认为“请输入”
    labelWidth: 90, // 选填，特殊指定当前item的宽度
  },
  {
    label: "选择框",
    type: "select",
    key: "xxx",
    placeholder: "xxx", // 选填，默认为“请输入”
    labelKey: "xxx", // 选填，默认为 label
    valueKey: "xxx", // 选填，默认为 value
    options: [
      {label: "显示", value: 1},
      {label: "隐藏", value: 2}
    ]
  },
  {
    label: "枚举选择框",
    type: "enum-select",
    key: "xxx",
    enum: "StudentStatus", // 枚举名称
    props: {
      xxx: xxxx, // 这里可以扩展组件内部的props
    }
  },
  {
    label: "日期选择",
    type: "date-select",
    key: "xxx",
  },
  {
    label: "日期范围选择",
    type: "date-range-select",
    keyStart: "起始时间key",
    keyEnd: "结束时间key"
  },
  {
    label: "级联选择",
    type: "cascader",
    key: "xxx",
    props: {
      url: "/api/course/classify",
    }
  }
]
 */
export default {
  name: 'CommonForm',
  props: {
    labelWidth: {
      type: Number,
      default: 70,
    },
    itemWidth: {
      type: Number,
      default: 188,
    },
    items: {
      type: Array,
      default: () => [],
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    // 如果有该函数，则不执行默认重置函数
    resetFunc: {
      type: Function,
    },
  },
  data() {
    return {
      initParams: {},
    };
  },
  created() {
    this.initParams = Object.assign({}, this.params);
  },
  mounted() {
    setTimeout(() => {
      window.$('.item-width').css({ width: this.itemWidth + 'px' });
    });
  },
  render() {
    return (
      <el-form label-width={this.labelWidth + 'px'} inline>
        {this.generateItems()}
        {
          <el-form-item>
            <el-button type={'primary'} size={'small'} on-click={this.onSearch}>
              搜索
            </el-button>
            <el-button size={'small'} on-click={this.onReset}>
              重置
            </el-button>
          </el-form-item>
        }
      </el-form>
    );
  },
  methods: {
    // on event
    onSearch() {
      this.$nextTick(() => {
        this.$emit('on-search', this.params);
      });
    },
    onReset() {
      if (this.resetFunc) {
        this.resetFunc(this.params);
      } else {
        this.resetParams();
      }
      this.onSearch();
    },
    onKeyDown(e) {
      if (e.key == 'Enter') {
        e.preventDefault();
        this.onSearch();
      }
    },
    onUpdateValue(val, key) {
      // eslint-disable-next-line vue/no-mutating-props
      this.params[key] = val;
    },
    // other
    resetParams() {
      for (const key in this.initParams) {
        if (this.needRest(key)) {
          // eslint-disable-next-line vue/no-mutating-props
          this.params[key] = this.initParams[key];
        }
      }
    },
    needRest(key) {
      const item = this.items.find((i) => i.key == key);
      if (item) {
        // 禁用不显示的，无需 reset
        if (item.disabled) {
          return false;
        }
        // 指定无需 reset
        if (item.noReset) {
          return false;
        }
      }
      return true;
    },
    // generate
    generateItems() {
      const items = [];
      this.items.forEach((item) => {
        if (item.disabled) {
          return;
        }
        let ele;
        if (item.slot) {
          ele = this.$slots[item.slot];
        } else {
          ele = this.generateItem(item);
        }
        if (ele) {
          items.push(
            <el-form-item
              {...{
                directives: this.itemDirectives(item),
              }}
              {...item.props}
              label={item.label + '：'}
              label-width={item.labelWidth + 'px'}
            >
              {ele}
            </el-form-item>,
          );
        }
      });
      return items;
    },
    generateItem(item) {
      let ele;
      switch (item.type) {
        case 'input':
          ele = (
            <el-input
              class="item-width"
              {...this.commonData(item)}
              v-model={this.params[item.key]}
              size={'small'}
              clearable
              placeholder={item.placeholder || '请输入'}
              nativeOn-keydown={this.onKeyDown}
            ></el-input>
          );
          break;
        case 'select':
          ele = (
            <el-select
              class="item-width"
              {...this.commonData(item)}
              v-model={this.params[item.key]}
              size={'small'}
              clearable
              placeholder={item.placeholder || '请选择'}
            >
              {(item.options || []).map((option) => {
                return (
                  <el-option
                    key={option[item.valueKey || 'value']}
                    value={option[item.valueKey || 'value']}
                    label={option[item.labelKey || 'label']}
                  ></el-option>
                );
              })}
            </el-select>
          );
          break;
        case 'enum-select':
          ele = (
            <EnumSelect
              class="item-width"
              {...this.commonData(item)}
              v-model={this.params[item.key]}
              type={item.enum}
              selector="select"
              clearable
            />
          );
          break;
        case 'date-select':
          ele = (
            <DateSelect
              {...this.commonData(item)}
              value={this.params[item.key]}
              on={{
                'update:value': (val) => this.onUpdateValue(val, item.key),
              }}
              size={'small'}
            ></DateSelect>
          );
          break;
        case 'date-range-select':
          ele = (
            <DateRangeSelect
              {...this.commonData(item)}
              start={this.params[item.keyStart]}
              end={this.params[item.keyEnd]}
              on={{
                'update:start': (val) => this.onUpdateValue(val, item.keyStart),
                'update:end': (val) => this.onUpdateValue(val, item.keyEnd),
              }}
              size={'small'}
            ></DateRangeSelect>
          );
          break;
        case 'cascader':
          ele = (
            <Cascader
              class="item-width"
              {...this.commonData(item)}
              v-model={this.params[item.key]}
            ></Cascader>
          );
          break;
      }
      return ele;
    },
    commonData(item) {
      return {
        attrs: item.attrs,
        props: item.props,
        style: item.style,
      };
    },
    itemDirectives(item) {
      const directives = [];
      if (item.vSwitch) {
        directives.push({
          name: 'switch',
          arg: item.vSwitch,
        });
      }
      return directives;
    },
  },
};
</script>

<style lang="scss" scoped>
.el-form--inline {
  margin-bottom: 10px;
}
.el-form--inline .el-form-item {
  margin-right: 20px;
  margin-bottom: 10px;
  &:last-of-type {
    margin-right: 0;
  }
}
::v-deep .el-form-item__label {
  padding: 0;
}
.el-button--small {
  border-radius: 4px;
  font-size: 14px;
  height: 32px;
}
</style>
